import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

function Input(props) {
  const [id] = useState(_.uniqueId('input'));

  const {
    type, label, rightIcon, leftIcon, className, error, dataAppend, dataPrepend, onKeyPress, ...restProps
  } = props;

  const handleKeyPress = useCallback((ev) => {
    if (type === 'numeric' && _.isNaN(parseInt(ev.key))) {
      ev.preventDefault();
    }
    if (onKeyPress) {
      onKeyPress(ev);
    }
  }, [type]);

  return (
    <div
      className={`otcInput ${className || ''} ${error ? 'hasError' : ''}`}

    >
      {label ? (
        <label
          htmlFor={id}
          data-append={dataAppend}
          data-prepend={dataPrepend}
        >
          {label}
        </label>
      ) : null}
      {leftIcon || null}
      <input
        id={id}
        type={type === 'numeric' ? 'text' : type}
        onKeyPress={handleKeyPress}
        {...restProps}
      />
      {rightIcon || null}
      {error ? <span className="error">{error}</span> : null}
    </div>
  );
}

Input.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  rightIcon: PropTypes.element,
  leftIcon: PropTypes.element,
  className: PropTypes.string,
  error: PropTypes.string,
  dataAppend: PropTypes.string,
  dataPrepend: PropTypes.string,
  onKeyPress: PropTypes.func,
};
Input.defaultProps = {
  type: 'text',
  label: '',
  rightIcon: undefined,
  leftIcon: undefined,
  className: '',
  error: '',
  dataAppend: undefined,
  dataPrepend: undefined,
  onKeyPress: () => {
  },
};

export default Input;
